module.exports = __webpack_public_path__ + "images/store_case_study/nextmarket-pic1_be7940b34a2d44f59140f17668242bc2.png";